import supports from '@/utils/supports';

const HISTORY_LIMIT = 10;

export default class Search {
	constructor({ category = 0, datetime = '', timeSlotStart = 420, timeSlotEnd = 1440, industry = 0, latitude = 0, longitude = 0, placeid = '', search = '', searchtype = '', siteId = 0, treatment = 0, ...args }) {
		this.category = parseInt(args.fixitCategoryId || category || 0);
		this.datetime = datetime ? new Date(Math.max(new Date(datetime), new Date())).toISOString().substr(0, 10) : datetime;
		this.timeSlotStart = parseInt(timeSlotStart);
		this.timeSlotEnd = parseInt(timeSlotEnd);
		this.industry = parseInt(industry);
		this.latitude = parseFloat(args.lat || latitude);
		this.longitude = parseFloat(args.lng || longitude);
		this.placeid = args.placeId || placeid;
		this.search = (args.areaName || args.name || search || '');
		
		if(typeof this.search == 'string'){
			this.search = this.search.replace(/\+/g, ' ');
		}

		this.searchtype = args.type ? args.type.toLowerCase() : searchtype.toLowerCase();
		this.siteId = siteId;
		this.treatment = parseInt(args.fixitTreatmentId || treatment || 0);
		this.url = args.url;
		this.urlFrendlyLink = args.urlFrendlyLink;
	}

	/**
	 * Execute search and navigate to search result. Pushing the search into the search history,
	 * and saving the last used coordinates of the user if user's geo-location was used.
	 * If searchType is `salon` we navigate directly to the salon's booking page.
	 */
	execute(router) {
		const path = this.searchtype == 'salon' ? `${this.urlFrendlyLink}/${this.siteId}` : '/sok'; // '/search';
		const uri = encodeURI(
			`${path}
            ?search=${this.search.replace(/ /g, '+')}
            &treatment=${this.treatment}
            &category=${this.category}
            &searchtype=${this.searchtype}
            &datetime=${this.datetime}
            &timeSlotStart=${this.timeSlotStart}
            &timeSlotEnd=${this.timeSlotEnd}
            &latitude=${this.latitude}
            &longitude=${this.longitude}
            &placeid=${this.placeid}
            &industry=${this.industry}
        `.replace(/[\r\n ]+/gm, '')
		);

		// Storing search and user coordinates
		if (supports.webStorage('localStorage')) {
			// Push to search history
			const searchHistory = JSON.parse(localStorage.getItem('SEARCH_HISTORY') || '[]');
			if (searchHistory.length >= HISTORY_LIMIT) searchHistory.shift(); // Limitting the history list
			searchHistory.push(location.origin + uri);
			localStorage.setItem('SEARCH_HISTORY', JSON.stringify(searchHistory));

			// Store last used coordinates (only for searchtype 'nearyou')
			if (this.searchtype === 'nearyou' && this.latitude && this.longitude && this.search) {
				localStorage.setItem('lastLatitude', this.latitude);
				localStorage.setItem('lastLongitude', this.longitude);
				localStorage.setItem('lastGeoAddress', this.search);
				localStorage.setItem('lastGeoSuccessTime', new Date().getTime());
			}
		}

		// Navigate to FNB,
		if (this.searchtype == 'salon') {
			location = uri;
		}

		// or regular search
		else {
			router
				.push({
					name: 'search',
					query: {
						search: this.search,
						searchtype: this.searchtype,
						category: this.category,
						treatment: this.treatment,
						datetime: this.datetime,
						timeSlotStart: this.timeSlotStart,
						timeSlotEnd: this.timeSlotEnd,
						latitude: this.latitude,
						longitude: this.longitude,
						placeid: this.placeid,
						industry: this.industry
					}
				})
				.catch(() => {});
		}
	}

	/**
	 * Gets the last executed search item by looking up history items stored in the localStorage.
	 */
	static get lastSearchHistoryItem() {
		if (supports.webStorage('localStorage')) {
			const searchHistory = JSON.parse(localStorage.getItem('SEARCH_HISTORY') || '[]');
			let uri = decodeURI(searchHistory[searchHistory.length - 1] || '');
			if (uri) {
				return new Search(
					JSON.parse(
						'{"' +
							uri
								.substr(uri.indexOf('?') + 1)
								.replace(/"/g, '\\"')
								.replace(/&/g, '","')
								.replace(/=/g, '":"') +
							'"}'
					)
				);
			}
		}

		return null;
	}
}
